export function padleft (input: number) {
    const str = `${input}`;
    const pad = '000000';
    return pad.substring(0, pad.length - str.length) + str;
}